export enum ContractHourlyTypeEnum {
	Occasional = 1,
	Long_Term = 2,
}

export enum ContractTypeEnum {
	Fixed = 1,
	Hourly = 2,
}

export enum ContractStatusEnum {
	Pending = 1,
	Active = 2,
	Cancelled = 3,
	Completed = 4,
	Archived = 5,
	Suspended = 6,
	Deleted = 7,
	Paused = 8,
	Expired = 9,
	Rejected = 10,
	Accepted = 11,
	Closed = 12,
}


